import React from 'react';

export default () => (
  <div className="no-selected-search">
    Please select a search.
  </div>
);
